<script setup>
// Landing de LLEVO — servicio de delivery y logística para negocios y usuarios
import Navbar from '../../components/Landing/Navbar.vue'
import Hero from '../../components/Landing/Hero.vue'
import BusinessSolutions from '../../components/Landing/BusinessSolutions.vue'
import AppSolutions from '../../components/Landing/AppSolutions.vue'
import Mandaditos from '../../components/Landing/Mandaditos.vue'
import HowItWorks from '../../components/Landing/HowItWorks.vue'
import CtaBand from '../../components/Landing/CtaBand.vue'
import Footer from '../../components/Landing/Footer.vue'
</script>

<template>
  <div class="relative min-h-screen overflow-x-hidden bg-white font-sans">
    <a
      href="#contenido"
      class="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-xl focus:bg-white focus:px-4 focus:py-3 focus:text-sm focus:font-bold focus:text-[#2b4162] focus:shadow-xl"
    >
      Saltar al contenido
    </a>

    <Navbar />

    <main id="contenido">
      <Hero />
      <BusinessSolutions />
      <AppSolutions />
      <Mandaditos />
      <HowItWorks />
      <CtaBand />
    </main>

    <Footer />
  </div>
</template>
